
import {Component, Vue} from 'vue-property-decorator';
import DynamicTable from '@/components/datatables/DynamicTableSimpleAsync.vue';
import DynamicTableSimpleAsync from '@/components/datatables/DynamicTableSimpleAsync.vue';
import {dispatchGetPrinterLogs} from '@/store/main/actions';
import {readPrinterLogs} from '@/store/main/getters';

@Component({
  components: {DynamicTableSimpleAsync},
})
export default class PrinterLogsList extends Vue {

  public headers = [
    // {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false },
    {text: this.$t('created_by_user'), sortable: false, value: 'created_by_user', align: 'left', type: 'user_object'},
    {text: this.$t('authorization_code'), sortable: true, value: 'authorization_code', align: 'left'},
    {text: this.$t('created_at'), sortable: false, value: 'created_at', align: 'left', type: 'date'},
    {text: this.$t('document_id'), sortable: true, value: 'document_id', align: 'right'},
    {text: `${this.$t('full_url')}`, sortable: true, value: 'full_url', align: 'right'},
    {text: `${this.$t('has_signature')}`, sortable: true, value: 'has_signature', align: 'center'},
  ];

  private numberOfPages: number = 0;
  private totalItems: number = 0;

  get printerLogs() {
    return readPrinterLogs(this.$store);
  }

  public async loadDataAPI(payload: any) {
    payload.with_stats = false;
    const response = await dispatchGetPrinterLogs(this.$store, payload);

    if (response) {
      this.totalItems = response?.total_items;
      this.numberOfPages = response?.total_items_page;
    }
  }

  public async mounted() {
    // location.reload();
    // await dispatchGetPrinterLogs(this.$store);
  }

}
